<template>
  <div class="page-home box-card">

    <div class="merquee-view" v-if="opxDrawings">
      <div class="merquee">
        <vueSeamlessScroll :data="opxDrawings" class="seamless-warp" :class-option="defaultOption">
          <div class="merquee-txt">
            <div class="merquee-item" v-for="(item, key) in opxDrawings" :key="key">
              <span>{{ item.date }}</span>
              <span>{{ item.account_id }}</span>
              <span>{{ $t('text66') }} {{ item.amount }} {{ $t('text67') }}</span>
            </div>
          </div>
        </vueSeamlessScroll>
      </div>

      <div class="merquee-more" @click="dialogVisible = true">
        <I18Lang id="text68" defaultText="更多" />
      </div>
    </div>

    <div class="box-card-header">
      <div class="right">
        <span class="btn kg-btn2" @click="$router.push({ name: 'publicDeposit' })">
          <I18Lang id="index5" defaultText="入金" />
        </span>
        <span class="btn kg-btn2" @click="$router.push({ name: 'publicWithdrawal' })">
          <I18Lang id="index6" defaultText="出金" />
        </span>
        <span class="btn kg-btn1" @click="$router.push({ name: 'userTransfer' })">
          <I18Lang id="index7" defaultText="转账" />
        </span>
        <i @click="refresh" class="refresh kg-refresh"></i>
      </div>
    </div>
    <div class="box-card-content">
      <div class="statistic-main">
        <div class="statistic-wallet">
          <div class="title">&ensp;&ensp;&ensp;
            <I18Lang id="my69" defaultText="现金账户余额($)" />&ensp;&ensp;&ensp;
          </div>
          <div class="name">
            <I18Lang id="my90" defaultText="现金账户余额($)" />
          </div>
          <div class="num">{{ accountInfo.cash_balance }} </div>
        </div>
        <div class="statistic-cash-account statistic-wallet-entry" @click="$router.push({ name: 'userWallet' })">
          <div class="title">
            <I18Lang id="index8" defaultText="钱包" />&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;
          </div>
          <div class="name">
            <I18Lang id="my67" defaultText="钱包余额(MEQ)" />
          </div>
          <div class="num">{{ accountInfo.wallet_balance || '0.00' }}</div>
        </div>
      </div>
    </div>

    <div class="box-card-main">
      <div class="statistic-user">
        <div class="statistic-item user-bg" v-if="userInfo.identity !== 3">
          <div class="statistic-item-info">
            <span class="text"> <I18Lang id="user106" defaultText="交易账户id" /> </span>
            <span class="num">{{ userInfo.account_no }}</span>
          </div>
        </div>
        <div class="statistic-item user-bg">
          <div class="statistic-item-info">
            <span class="text"> <I18Lang id="user107" defaultText="交易账户密码" /> </span>
            <span class="num">******
              <EditAccountPass />
            </span>
          </div>
        </div>
      </div>

      <div class="account">
        <div class="account-title">
          <I18Lang id="user39" defaultText="交易账户" />
        </div>

        <div class="account-list" v-if="accountList && accountList.length > 0">
          <div class="account-item" v-for="(item, key) in accountList" :key="key">
            <div class="item">
              <div class="label">
                {{ item.trade_model === 0 ? $t("public79") : $t("public80") }}
              </div>
              <div class="value">{{ item.account_no }}</div>
            </div>
            <div class="item">
              <div class="label">
                <I18Lang id="user43" defaultText="杠杆比例" />
              </div>
              <div class="value">
                {{ item.leverage }}
              </div>
            </div>
            <div class="item">
              <div class="label">
                <I18Lang id="user44" defaultText="账户余额" />
              </div>
              <div class="value"> {{ item.balance }}</div>
            </div>
          </div>
        </div>

        <div class="btn-group">
          <div class="kg-btn5" @click="
            $router.push({ name: 'userTransfer', query: { type: 'deposit' } })
            ">
            <I18Lang id="user108" defaultText="Trading Accounts Deposit" />
          </div>
          <div class="kg-btn5" @click="
            $router.push({
              name: 'userTransfer',
              query: { type: 'withdrawal' },
            })
            ">
            <I18Lang id="user109" defaultText="Trading Accounts Withdrawal" />
          </div>
          <div class="kg-btn5 trade-entry-btn" @click="enterTradeSystem">
            <I18Lang id="usermenu6" defaultText="开始交易" />
          </div>
        </div>
      </div>
    </div>

    <el-dialog :title="$t('text71')" :visible.sync="dialogVisible" width="30%" :close-on-click-modal="false"
      :close-on-press-escape="false" class="info-dialog rank-dialog">

      <div class="merquee-list">
        <div class="merquee-text" v-for="(item, key) in opxDrawings" :key="key">
          <span>{{ item.date }}</span>
          <span>{{ item.account_id }}</span>
          <span>{{ $t('text66') }} {{ item.amount }} {{ $t('text67') }}</span>
        </div>
      </div>

    </el-dialog>

    <el-dialog :title="$t('text70')" :visible.sync="dialogRuleVisible" width="500px" :close-on-click-modal="false"
      :close-on-press-escape="false" class="info-dialog rule-dialog" @close="onRuleClose">
      <div class="desc" v-html="$t('text69')">
      </div>
    </el-dialog>

  </div>
</template>

<script>
import { mapState } from 'vuex'
import EditAccountPass from './components/EditAccountPass.vue'
import VueSeamlessScroll from 'vue-seamless-scroll'
import cookie from '@utils/cookie'
import { enterTradeSystem } from '@utils/tradeSystem'
export default {
  name: 'home',
  data () {
    return {
      isloading: false,
      accountInfo: {},
      accountList: {},
      opxDrawings: [],
      dialogRuleVisible: false,
      dialogVisible: false,
      allowScroll: true,
      defaultOption: {
        step: 0.3, // 数值越大速度滚动越快
        limitMoveNum: 1, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 2, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000
      }
    }
  },
  components: {
    EditAccountPass,
    VueSeamlessScroll
  },
  created () {
    this.getAccountInfo()
    this.getAccountList()
    this.getOpxDrawings()
    this.setDialog()
  },
  watch: {
    userInfo () {
      if (!this.userInfo.is_recharge && !sessionStorage.getItem('dialogRuleVisible')) {
        this.dialogRuleVisible = true
      }
    }
  },
  methods: {
    enterTradeSystem () {
      const tradeAccountId = this.userInfo && this.userInfo.account_no
        ? this.userInfo.account_no
        : (this.accountList && this.accountList.length > 0 ? this.accountList[0].account_no : '')
      enterTradeSystem(tradeAccountId)
    },
    setDialog () {
      const today = new Date().toISOString().slice(0, 10)
      const lastShowDate = localStorage.getItem('homeDialogVisibleDate')
      if (lastShowDate !== today) {
        this.dialogVisible = true
        localStorage.setItem('homeDialogVisibleDate', today)
      }
    },
    onRuleClose () {
      sessionStorage.setItem('dialogRuleVisible', '1')
    },
    onCopy () {
      this.$copyText(this.userInfo.account_pw).then(
        (e) => {
          this.$alert(this.$t('public27'), {
            confirmButtonText: this.$t('my25'),
            center: true,
            dangerouslyUseHTMLString: true,
            customClass: 'success-alert',
            callback: (action) => { }
          })
        },
        function (e) { }
      )
    },
    getOpxDrawings () {
      this.$http.get('/api/activity/opxDrawings').then((result) => {
        this.opxDrawings = result
      })
    },
    getAccountInfo () {
      this.$http.get('/api/account/info').then((result) => {
        this.accountInfo = result
      })
    },
    getAccountList () {
      this.$http
        .get('/api/account/list', {
          params: { national_market: cookie.get('national_market') }
        })
        .then((result) => {
          this.accountList = result
        })
    },
    refresh () {
      this.isloading = true
      this.$store
        .dispatch('getUserInfo')
        .then((result) => {
          this.isloading = false
        })
        .catch(() => {
          this.isloading = false
        })
      this.getAccountInfo()
      this.getAccountList()
    }
  },
  computed: {
    ...mapState(['userInfo', 'currMarket', 'currMarketId'])
  }
}
</script>
<style scoped lang="scss">
::v-deep .rank-dialog {
  .el-dialog {
    width: 650px !important;
    min-height: 420px;
    height: 420px;
    background: url("../../../assets/img/user/short-bg.png") no-repeat center / 100% 100%;

  }
}

::v-deep .rule-dialog {
  .el-dialog {
    width: 606px !important;
    min-height: 480px;
    height: 480px;
    background: url("../../../assets/img/user/short-bg.png") no-repeat center / 100% 100%;
  }

  .desc {
    padding: 0 30px;
    height: 350px;
    overflow-y: auto;
    padding-top: 20px;

    h3 {
      margin-top: 20px;
    }

    h3,
    p {
      color: #fff;
      margin-bottom: 5px;
    }
  }
}

.merquee-view {
  display: flex;
  justify-content: space-between;
  padding-top: 10px;
  width: 100%;

  .merquee {
    flex: 1;
    width: 100%;
    overflow: hidden;
  }

  .merquee-more {
    font-size: 14px;
    flex: 0 0 30px;
    text-align: right;
    margin-left: 20px;
    width: 30px;
    color: #fff;
    cursor: pointer;
    text-decoration: underline;
  }
}

.merquee {
  height: 25px;
  line-height: 25px;
  box-sizing: border-box;
  word-break: break-all;
  white-space: nowrap;
  overflow: hidden;
}

.merquee-txt {
  display: inline-block;
}

.merquee-item {
  margin: 0 10px;
  display: inline-block;
}

.merquee-item span {
  font-size: 14px;
  color: #fff;
  display: inline-block;
  margin: 0 1px;
}

.merquee-list {
  padding: 0 20px;
  height: 300px;
  overflow-y: auto;

  .merquee-text {
    display: block;
    margin-bottom: 5px;

    span {
      font-size: 14px;
      color: #fff;
      display: inline-block;
      margin: 0 1px;
    }
  }
}

@keyframes marqueeTransform {
  0% {
    transform: translate(0, 0);
  }

  100% {
    transform: translate(-100%, 0);
  }
}

.page-home {
  background: url("../../../assets/img/index-bg.png") no-repeat bottom / 100% auto;
  background-attachment: fixed;
  min-height: 100vh;
  margin: 0 -38px;
  padding: 0 38px;

  .box-card-header {
    padding-top: 20px;
    display: flex;
    margin-bottom: 15px;
    justify-content: right;

    .right {
      display: flex;
      align-items: center;

      .btn {
        margin-left: 5px;
        color: #fff;
      }

      .refresh {
        margin-left: 5px;
      }
    }
  }

  .box-card-main {
    display: flex;
    justify-content: space-between;
  }

  .statistic-main {
    display: flex;
    justify-content: space-between;
    padding-right: 100px;
    padding-left: 50px;
    font-family: Arial-BoldMT;

    .statistic-wallet,
    .statistic-cash-account {
      width: 475px;
      height: 336px;
      position: relative;
      background: url("../../../assets/img/index/q.png") no-repeat center / 100% 100%;

      .title {
        position: absolute;
        z-index: 100;
        text-align: center;
        transform: rotateY(40deg);
        top: 0;
        color: #fff;
        font-size: 18px;
        top: 12px;
      }

      .name {
        position: absolute;
        z-index: 100;
        width: 475px;
        text-align: center;
        transform: rotateY(35deg);
        bottom: 120px;
        color: #fff;
        font-size: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .num {
        position: absolute;
        z-index: 100;
        width: 500px;
        text-align: center;
        transform: rotateY(35deg);
        bottom: 70px;
        left: 10px;
        color: #fff;
        font-size: 25px;
        display: flex;
        align-items: center;
        justify-content: center;

        i {
          font-size: 18px;
          margin-right: 10px;
        }
      }
    }

    .statistic-wallet {
      .title {
        transform: rotateY(40deg) rotate(1deg);
        left: 50px;
        top: 20px;
      }

      .name {
        margin-left: 28px;
      }
    }

    .statistic-cash-account {
      background: url("../../../assets/img/index/s.png") no-repeat center / 100% 100%;

      .title {
        transform: rotateY(40deg) rotate(-1deg);
        left: auto;
        right: 50px;
        top: 22px;
      }

      .num {
        left: auto;
        right: 0px;
      }
    }

    .statistic-wallet-entry { cursor: pointer; }
  }

  .btn-add-user {
    margin-top: 20px;
    margin-left: 40px;
    width: 150px;
    text-align: center;
    position: relative;

    &::before {
      content: "";
      position: absolute;
      display: block;
      width: 30px;
      height: 31px;
      left: 15px;
      top: 7px;
      background: url("../../../assets/img/+.png") no-repeat center / 100%;
    }
  }

  .statistic-user {
    margin-top: 20px;
  }

  .statistic-item {
    width: 360px;
    height: 80px;
    margin-top: 50px;
    margin-left: 50px;

    &.user-bg {
      background: url("../../../assets/img/user-st1.png") no-repeat center / 100% auto;
    }

    &.lock-bg {
      background: url("../../../assets/img/user-st1.png") no-repeat center / 100% auto;
    }

    .statistic-item-info {
      padding-left: 100px;

      .text {
        font-size: 14px;
        font-weight: bold;
        color: #ffffff;
        display: block;
        text-align: center;
        padding-top: 10px;
      }

      .num {
        font-size: 28px;
        font-weight: 400;
        display: block;
        text-align: center;
        color: #00cbfa;
      }
    }
  }

  .account {
    flex: 0 0 490px;
    margin-right: 70px;

    .account-title {
      font-size: 20px;
      font-family: Arial;
      font-weight: bold;
      color: #01b2f5;
      line-height: 70px;
      padding-bottom: 20px;
      border-bottom: 1px solid #01b2f5;
    }

    .account-list {
      .account-item {
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #01b2f5;
        padding: 20px 0;
        font-family: ArialMT;

        .item {
          &:nth-child(1) {
            flex: 0 0 40%;
          }

          &:nth-child(2) {
            flex: 0 0 20%;
          }

          &:nth-child(3) {
            flex: 0 0 40%;
          }

          .label {
            font-size: 16px;
            font-weight: 400;
            color: #01b2f5;
            margin-bottom: 15px;
            text-align: center;
          }

          .value {
            font-size: 18px;
            font-weight: bold;
            color: #ffffff;
            text-align: center;
          }
        }
      }
    }

    .btn-group {
      display: flex;
      justify-content: space-between;
      gap: 12px;
      padding-top: 22px;

      .kg-btn5 {
        flex: 1;
        width: auto;
        min-width: 0;
        padding: 0 12px;
        white-space: nowrap;
      }

      .trade-entry-btn {
        box-shadow: 0 0 16px rgba(0, 203, 250, .28);
      }
    }
  }
}

@media only screen and (max-width: 755px) {
  .page-home {
    background: url("../../../assets/img/index-bg.png") no-repeat bottom / 100% auto;
    background-attachment: fixed;
    min-height: 100vh;
    margin: 0 -38px;
    padding: 0 38px;

    .box-card-header {
      padding-top: 20px;
      display: flex;
      margin-bottom: 15px;
      justify-content: center;

      .right {
        display: flex;
        align-items: center;

        .btn {
          margin-left: 5px;
          color: #fff;
        }

        .refresh {
          margin-left: 5px;
        }
      }
    }

    .box-card-main {
      display: block;
      justify-content: space-between;
    }

    .statistic-main {
      display: flex;
      justify-content: space-between;
      padding-right: 0;
      padding-left: 0;
      font-family: Arial-BoldMT;

      .statistic-wallet,
      .statistic-cash-account {
        width: 475px;
        height: 336px;
        position: relative;
        background: url("../../../assets/img/index/q.png") no-repeat center / 100% 100%;

        .title {
          position: absolute;
          z-index: 100;
          width: 200px;
          text-align: center;
          transform: rotateY(40deg);
          top: 0;
          color: #fff;
          font-size: 23px;
          top: 12px;
        }

        .name {
          position: absolute;
          z-index: 100;
          width: 325px;
          text-align: center;
          transform: rotateY(35deg);
          bottom: 120px;
          color: #fff;
          font-size: 20px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .num {
          position: absolute;
          z-index: 100;
          width: 320px;
          text-align: center;
          transform: rotateY(35deg);
          bottom: 70px;
          left: 10px;
          color: #fff;
          font-size: 25px;
          display: flex;
          align-items: center;
          justify-content: center;

          i {
            font-size: 18px;
            margin-right: 10px;
          }
        }
      }

      .statistic-wallet {
        margin-right: 10px;

        .title {
          transform: rotateY(40deg) rotate(1deg);
          left: 0;
        }

        .name {
          margin-left: 28px;
        }
      }

      .statistic-cash-account {
        margin-left: 10px;

        background: url("../../../assets/img/index/s.png") no-repeat center / 100% 100%;

        .title {
          transform: rotateY(40deg) rotate(-1deg);
          left: auto;
          right: 0;
          top: 18px;
        }

        .num {
          left: auto;
          right: 10px;
        }
      }

      .statistic-wallet-entry { cursor: pointer; }
    }

    .btn-add-user {
      margin-top: 20px;
      margin-left: 40px;
      width: 150px;
      text-align: center;
      position: relative;

      &::before {
        content: "";
        position: absolute;
        display: block;
        width: 30px;
        height: 31px;
        left: 15px;
        top: 7px;
        background: url("../../../assets/img/+.png") no-repeat center / 100%;
      }
    }

    .statistic-user {
      display: flex;
      margin-top: 40px;
    }

    .statistic-item {
      width: 360px;
      height: 80px;
      margin-top: 0;
      margin-left: 0;

      &.user-bg {
        background: url("../../../assets/img/user-st1.png") no-repeat center / 100% auto;
      }

      &.lock-bg {
        background: url("../../../assets/img/user-st1.png") no-repeat center / 100% auto;
      }

      .statistic-item-info {
        padding-left: 100px;

        .text {
          font-size: 14px;
          font-weight: bold;
          color: #ffffff;
          display: block;
          text-align: center;
          padding-top: 10px;
        }

        .num {
          font-size: 28px;
          font-weight: 400;
          display: block;
          text-align: center;
          color: #00cbfa;
        }
      }
    }

    .account {
      flex: 0 0 490px;
      margin-right: 0;
      margin-top: 30px;

      .account-title {
        font-size: 20px;
        font-family: Arial;
        font-weight: bold;
        color: #01b2f5;
        line-height: 70px;
        padding-bottom: 20px;
        border-bottom: 1px solid #01b2f5;
      }

      .account-list {
        .account-item {
          display: flex;
          justify-content: space-between;
          border-bottom: 1px solid #01b2f5;
          padding: 20px 0;
          font-family: ArialMT;

          .item {
            &:nth-child(1) {
              flex: 0 0 40%;
            }

            &:nth-child(2) {
              flex: 0 0 20%;
            }

            &:nth-child(3) {
              flex: 0 0 40%;
            }

            .label {
              font-size: 16px;
              font-weight: 400;
              color: #01b2f5;
              margin-bottom: 15px;
              text-align: center;
            }

            .value {
              font-size: 18px;
              font-weight: bold;
              color: #ffffff;
              text-align: center;
            }
          }
        }
      }

      .btn-group {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        gap: 16px;
        padding-top: 22px;

        .kg-btn5 {
          width: calc(50% - 8px);
          box-sizing: border-box;
        }

        .trade-entry-btn {
          width: 100%;
        }
      }
    }
  }
}
</style>
